import React, { Component } from "react";

class UserInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: this.props.informacionUsuario.Nombre,
            login: this.props.informacionUsuario.Login,
            mail: this.props.informacionUsuario.Email,
            sucursalId: (this.props.informacionUsuario.SucursalId) ? this.props.informacionUsuario.SucursalId : "0",
            sectorId: (this.props.informacionUsuario.SectorId) ? this.props.informacionUsuario.SectorId : "0"
        }
    }

    onHandleChange(event) {
        let regExp = /^[0-9a-zA-Z]*$/
        let result = regExp.test(event.target.value);
        if (!result) {
            event.preventDefault();
        }

        let name = event.target.name;
        let nameUserInfo = event.target.dataset.userinfo;
        let value = nameUserInfo == 'Login' ? event.target.value.trim() : event.target.value;

        this.props.updateInformacionUsuario(nameUserInfo, value);
        this.setState({ [name]: value });
    }

    onNombreKeyPress(event) {
        let regExp = /^[a-zA-Z\. _\u00C0-\u00FF]*$/gi
        let result = regExp.test(event.key);
        if (!result) {
            event.preventDefault();
        }
    }

    onLoginKeyPress(event) {
        let result = event.key == " " ? false : true;
        if (!result) {
            event.preventDefault();
        }
        let regExpe = /^[¨¿¡´°¬]*$/
        let resp = regExpe.test(event.key);
        if (resp) {
            event.preventDefault();
        } 
    }

    onHandleChangeLogin(event) {
        let result = event.target.value == " " ? false : true;
        let caracteresProhibido=["¨","¿","¡","´","°","¬"];

        if (!result) {
            event.preventDefault();
        }   
        
        let regExpe = /^[¨¿¡´°¬]*$/
        let resp = regExpe.test(event.target.value);
        if (resp) {
            event.preventDefault();
        }

        for (let index = 0; index < caracteresProhibido.length; index++) {
            if(event.target.value.toString().includes(caracteresProhibido[index])){
                this.props.updateInformacionUsuario("Login", event.target.value.replace(caracteresProhibido[index],"").trim());
                this.setState({ [name]: event.target.value.toString().replace(caracteresProhibido[index],"").trim() });
            }else{
                this.props.updateInformacionUsuario("Login", event.target.value.toString().trim());
                this.setState({ [name]: event.target.value.toString().trim() });
            }                    
        }
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }

    componentDidUpdate(prevProps) {

        //SE APLICA ESTA CONDICIÓN PORQUE SIGNIFICA QUE YA SE REALIZÓ LA OBTENCIÓN DE DATOS CON LOS NOMBRES DE LOGIN DE USUARIO QUE SE NECESITAN PARA LA VALIDACIÓN DE LOGIN
        if ((this.props.productos && this.props.productos.length > 0 /*&& prevProps.productos.length != this.props.productos.length*/)) {

            let context = this;
            let form = $("#user-info-form");
            let usedLogins = [];
            this.props.usuariosActuales.map(u => {
                if (this.props.informacionUsuario.Id) {
                    if (u.Login != this.props.informacionUsuario.Login) {
                        usedLogins.push(u.Login)
                    }
                } else {
                    usedLogins.push(u.Login)
                }
            });

            $.validator.addMethod("valueNotEquals", function (value, element, arg) {
                return arg != value;
            });

            $.validator.addMethod("valueNotIn", function (value, element, arg) {
                return !arg.some(a => a.toLowerCase() == value.toLowerCase());
            });

            $.validator.addMethod("validaEmail", function (value, element) {
                return this.optional(element) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
            });

            form.validate({
                rules: {
                    nombre: { required: true, minlength: 5, maxlength: 40 },
                    login: { required: true, minlength: 5, maxlength: 20, valueNotIn: usedLogins },
                    mail: { required: true, minlength: 5, maxlength: 60, validaEmail: true },
                    sucursalId: { required: true, valueNotEquals: "0" },
                    sectorId: { required: true, valueNotEquals: "0" }
                },
                messages: {
                    nombre: {
                        required: "Por favor, ingrese el nombre y apellido del usuario.",
                        minlength: "Ingrese al menos 5 caracteres"
                    },
                    login: {
                        required: "Por favor, ingrese un nombre de login para el usuario.",
                        minlength: "Ingrese al menos 5 caracteres",
                        valueNotIn: "El nombre de login ya existe para otro usuario."
                    },
                    mail: {
                        required: "Por favor, ingrese un correo electrónico.",
                        minlength: "Ingrese al menos 5 caracteres",
                        validaEmail: "Por favor, ingrese un correo electrónico válido."
                    },
                    sucursalId: { valueNotEquals: "Por favor, seleccione una sucursal." },
                    sectorId: { valueNotEquals: "Por favor, seleccione un sector." }
                }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            nombre: nextProps.informacionUsuario.Nombre,
            login: nextProps.informacionUsuario.Login,
            mail: nextProps.informacionUsuario.Email,
            sucursalId: (nextProps.informacionUsuario.SucursalId) ? nextProps.informacionUsuario.SucursalId : "0",
            sectorId: (nextProps.informacionUsuario.SectorId) ? nextProps.informacionUsuario.SectorId : "0"
        });
    }

    render() {
        let oSector = this.props.sectores.map(function (s, index) {
            return <option key={"sector-" + index} value={s.Id}>{s.Descripcion}</option>
        });

        let oSucursal = this.props.sucursales.map(function (o, index) {
            return <option key={"sucursal-" + index} value={o.Id}>{o.Descripcion}</option>
        });

        return (
            <form id="user-info-form">
                <div className="row bottom-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">Nombre y apellido</label><br />
                        <input onPaste={this.onPasteText} className="form-control default-input" type="text" name="nombre" id="nombre"
                            value={this.state.nombre} maxLength="40" data-userinfo="Nombre"
                            onChange={(event) => this.onHandleChange(event)} onKeyPress={this.onNombreKeyPress} />
                    </div>
                </div>

                <div className="row bottom-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">Login</label><br />
                        <input onPaste={this.onPasteText} className="form-control default-input" type="text" name="login" id="login"
                            value={this.state.login} maxLength="20" data-userinfo="Login" autoComplete="off"
                            onChange={(event) => this.onHandleChangeLogin(event)} onKeyPress={this.onLoginKeyPress} />
                    </div>
                </div>

                <div className="row bottom-separator-xs">
                    <div className="col-xs-3">
                        <label className="label-primary">Sucursal</label><br />
                        <select name="sucursalId" id="sucursalId" className="form-control default-input"
                            value={this.state.sucursalId} data-userinfo="SucursalId"
                            onChange={(event) => this.onHandleChange(event)}>
                            <option value="0">Seleccione...</option>
                            {oSucursal}
                        </select>
                    </div>

                    <div className="col-xs-3">
                        <label className="label-primary">Sector</label><br />
                        <select name="sectorId" id="sectorId" className="form-control default-input"
                            value={this.state.sectorId} data-userinfo="SectorId"
                            onChange={(event) => this.onHandleChange(event)}>
                            <option value="0">Seleccione...</option>
                            {oSector}
                        </select>
                    </div>
                </div>

                <div className="row bottom-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">Correo electrónico</label>
                        <input onPaste={this.onPasteText} className="form-control default-input" type="text" name="mail" id="mail"
                            value={this.state.mail} maxLength="60" data-userinfo="Email"
                            onChange={(event) => this.onHandleChange(event)} />
                    </div>
                </div>
            </form>
        );
    }
}

export default UserInfo;